export interface ServerError {
    data: string;
    errorCode: number;
}

export function isServerError(s: any): s is ServerError {
    return "data" in s;
}
